<template>
  <div>
    <!-- 采购申请单新增与明细维护弹窗组件 -->
    <el-dialog
      v-if="visible"
      class="po-req-custom-dialog-wrapper"
      custom-class="po-req-custom-dialog"
      v-dialogDrag
      :visible.sync="visible"
      :width="tabWidth"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      append-to-body>
      
      <!-- 统一白底极简标题栏（无彩色背景，与齐套料页面完全协调） -->
      <div slot="title" class="dialog-clean-header">
        <span class="header-main-title">{{ dialogTitle }}</span>

      </div>

      <!-- 弹窗主体滚动区域 -->
      <div class="dialog-scroll-body">
        <!-- 模块 1：基本信息面板 -->
        <div class="panel-section-box">
          <div class="panel-section-head">
            <span class="head-title">基本信息</span>
            <span class="head-subtitle">请核对申请单据参数</span>
          </div>
          <el-form :model="mainRow" label-width="80px" size="small" inline class="clean-form-grid">
            <el-form-item label="申请单号">
              <el-input v-model="mainRow.IDNO" placeholder="保存后自动生成" disabled style="width: 170px;"></el-input>
            </el-form-item>
            <el-form-item label="申请日期">
              <el-date-picker v-model="mainRow.REQDTTM" type="date" value-format="yyyy-MM-dd" style="width: 170px;"></el-date-picker>
            </el-form-item>
            <el-form-item label="申请人员">
              <el-input v-model="mainRow.STAFF" style="width: 170px;"></el-input>
            </el-form-item>
            <el-form-item label="需求部门">
              <el-select v-model="mainRow.DEPTNO" filterable style="width: 170px;">
                <el-option v-for="d in deptOptions" :key="d.CODE" :label="d.CNAME" :value="d.CODE"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="请购类别">
              <el-select v-model="mainRow.REQTY" style="width: 170px;">
                <el-option label="物料请购" value="398610"></el-option>
                <el-option label="资产请购" value="398620"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="申请备注" class="form-item-full">
              <el-input v-model="mainRow.RMK" placeholder="请输入排产欠料申请备注信息..."></el-input>
            </el-form-item>
          </el-form>
        </div>

        <!-- 模块 2：请购明细卡片与工具栏 -->
        <div class="detail-card-panel">
          <div class="detail-toolbar-wrap">
            <div class="toolbar-left">
              <span class="detail-title">请购明细清单</span>
              <span class="detail-count-badge">共 {{ dtlData.length }} 项</span>

              <!-- 批量分配供应商：一体化极简组合（美观协调、无突兀色块） -->
              <div class="batch-alloc-inline">
                <span class="batch-alloc-label">批量供应商:</span>
                <div class="batch-alloc-field">
                  <sup-table-select
                    v-model="batchSupNo"
                    :name.sync="batchSupNm"
                    :options="supOptions"
                    placeholder="选择供应商"
                  />
                </div>
                <button
                  type="button"
                  class="btn-batch-apply"
                  :disabled="!batchSupNo && !batchSupNm"
                  @click="applyBatchSupplier">
                  应用全部
                </button>
              </div>
            </div>

            <!-- 右侧统计：简洁克制文本展示 -->
            <div class="toolbar-stat-right">
              <span class="stat-cell">合计数量: <b>{{ totalDtlQty }}</b></span>
              <span class="stat-sep">/</span>
              <span class="stat-cell">预估金额: <b class="amt">¥ {{ totalDtlAmt }}</b></span>
            </div>
          </div>

          <!-- 明细表格 -->
          <el-table
            :data="dtlData"
            border
            size="mini"
            class="po-req-detail-table"
            height="435"
            highlight-current-row>
            <el-table-column label="序号" type="index" width="48" align="center"></el-table-column>
            
            <el-table-column label="物品类别" width="80" align="center">
              <template slot-scope="scope">
                <span style="color: #64748b; font-size: 12px;">{{ scope.row.MATTYPE === 'PRD' ? '产成品' : (scope.row.MATTYPE === 'SMP' ? '样板' : '原材料') }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="MATNO" label="物料编码" width="130" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="cell-matno">{{ scope.row.MATNO }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="MATNM" label="物料名称" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="SPECNM" label="规格型号" min-width="110" show-overflow-tooltip></el-table-column>
            <el-table-column prop="UNITNM" label="单位" width="55" align="center"></el-table-column>

            <!-- 建议供应商列 (下拉表格选择) -->
            <el-table-column label="建议供应商" min-width="210">
              <template slot-scope="scope">
                <sup-table-select
                  v-model="scope.row.SUPNO"
                  :name.sync="scope.row.SUPNM"
                  :options="supOptions"
                  placeholder="点击选择供应商"
                />
              </template>
            </el-table-column>

            <el-table-column label="申请数量" width="115" align="center">
              <template slot-scope="scope">
                <el-input-number
                  size="mini"
                  v-model="scope.row.QTY"
                  :min="1"
                  :precision="0"
                  controls-position="right"
                  style="width: 100px;"
                  @input="calcRowAmt(scope.row)">
                </el-input-number>
              </template>
            </el-table-column>

            <el-table-column label="预估单价" width="100" align="center">
              <template slot-scope="scope">
                <el-input-number
                  size="mini"
                  v-model="scope.row.PRC"
                  :min="0"
                  :precision="2"
                  controls-position="right"
                  style="width: 90px;"
                  @input="calcRowAmt(scope.row)">
                </el-input-number>
              </template>
            </el-table-column>

            <el-table-column prop="AMT" label="总金额" width="100" align="right">
              <template slot-scope="scope">
                <span style="font-weight: 600; color: #d97706;">¥ {{ scope.row.AMT }}</span>
              </template>
            </el-table-column>

            <el-table-column label="建议到货日期" width="135" align="center">
              <template slot-scope="scope">
                <el-date-picker size="mini" v-model="scope.row.REQDTTM" type="date" value-format="yyyy-MM-dd" style="width: 125px;"></el-date-picker>
              </template>
            </el-table-column>

            <el-table-column prop="RMK" label="来源备注" min-width="140" show-overflow-tooltip></el-table-column>

            <el-table-column label="操作" width="65" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="text" class="btn-clean-del" @click="perDel(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 模块 3：弹窗底部操作栏 (极简规范) -->
      <div class="dialog-custom-footer">
        <div class="footer-summary">
          <span>共 <b style="color: #0f172a;">{{ dtlData.length }}</b> 项物料，合计 <b style="color: #0f172a;">{{ totalDtlQty }}</b> 件</span>
        </div>
        <div class="footer-btns">
          <el-button size="small" class="btn-cancel" @click="visible = false">取 消</el-button>
          <el-button type="primary" size="small" class="btn-confirm" :loading="saving" @click="saveRec">保存采购申请单</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import supTableSelect from './sup_table_select.vue';
import { getBaseData } from '@/api/user';
import { getDate } from '@/api/Select';

export default {
  name: 'PoReqDialog',
  components: { supTableSelect },
  data() {
    return {
      visible: false,
      saving: false,
      dialogTitle: '采购申请单',
      tabWidth: window.innerWidth > 1400 ? '1360px' : '96%',
      corpid: this.$cookies.get('v_corpid') || '',
      username: this.$cookies.get('v_usernm') || this.$cookies.get('v_telno') || '计划员',
      deptOptions: [
        { CODE: '生产部', CNAME: '生产部' },
        { CODE: '计划部', CNAME: '计划部' },
        { CODE: '采购部', CNAME: '采购部' }
      ],
      supOptions: [], // 全部合格供应商候选列表 [{ IDNO, SUPNM, IDSEQ }]
      batchSupNo: '', // 顶部工具栏选中的批量分配供应商编码
      batchSupNm: '', // 顶部工具栏选中的批量分配供应商名称
      mainRow: {
        IDNO: '',
        REQDTTM: '',
        STAFF: '',
        DEPTNO: '生产部',
        REQTY: '398610',
        STFG: 'N',
        RMK: ''
      },
      dtlData: []
    };
  },
  computed: {
    totalDtlQty() {
      return this.dtlData.reduce((acc, row) => acc + (Number(row.QTY) || 0), 0);
    },
    totalDtlAmt() {
      const sum = this.dtlData.reduce((acc, row) => acc + (Number(row.AMT) || 0), 0);
      return sum.toFixed(2);
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          const dragDom = document.querySelector('.po-req-custom-dialog');
          if (dragDom) {
            dragDom.style.left = '0px';
            dragDom.style.top = '0px';
          }
        });
      }
    }
  },
  mounted() {
    this.initDeptOptions();
    this.initSupplierOptions();
  },
  methods: {
    initDeptOptions() {
      getBaseData('xuper_auth/getTableRecMany', 'CORPID', this.corpid, '', '', 'v_hr_dept', '').then(res => {
        if (res && res.code === '200' && Array.isArray(res.result) && res.result.length) {
          this.deptOptions = res.result.map(d => ({
            CODE: d.DEPTNM || d.IDNO || d.CNAME,
            CNAME: d.DEPTNM || d.CNAME
          }));
        }
      }).catch(() => {});
    },

    initSupplierOptions() {
      getBaseData('xuper_auth/getBaseData', 'CORPID', this.corpid, '', '', 'v_bs_sup', '').then(res => {
        if (res && res.code === '200' && Array.isArray(res.result)) {
          this.supOptions = res.result.map(s => ({
            IDNO: s.IDNO || '',
            SUPNM: s.SUPNM || s.CNAME || '',
            IDSEQ: s.IDSEQ || ''
          }));
        }
      }).catch(() => {});
    },

    /**
     * 对外公开：将推导出的欠料明细注入弹窗
     * @param {Array} shortageRows 欠料物料数组
     * @param {Object} meta 来源元信息
     */
    openWithShortageMaterials(shortageRows, meta = {}) {
      if (!shortageRows || !shortageRows.length) {
        this.$message.warning('暂无欠料物料明细可生成申请单');
        return;
      }

      const today = getDate ? getDate('day') : new Date().toISOString().slice(0, 10);
      const shipDate = new Date();
      shipDate.setDate(shipDate.getDate() + 3);
      const defaultShipDate = shipDate.toISOString().slice(0, 10);

      this.dialogTitle = meta.title || '采购申请单';
      this.batchSupNo = '';
      this.batchSupNm = '';
      this.mainRow = {
        IDNO: '',
        REQDTTM: today,
        STAFF: this.username,
        DEPTNO: meta.deptNo || '生产部',
        REQTY: '398610',
        STFG: 'N',
        RMK: meta.remark || '预测排产欠料自动生成申请单'
      };

      this.dtlData = shortageRows.map(r => {
        const qty = Number(r.shortageQty || r.pushQty || 1);
        const prc = Number(r.prc || 0);
        return {
          MATTYPE: 'MAT',
          MATNO: r.matNo || '',
          MATNM: r.matName || '',
          SPECNM: r.spec || r.model || '',
          UNITNM: r.unit || 'PCS',
          QTY: qty,
          PRC: prc,
          AMT: (qty * prc).toFixed(2),
          SUPNO: r.supNo || '',
          SUPNM: r.supNm || '',
          REQDTTM: r.shpdttm || defaultShipDate,
          RMK: r.sourceSkuLabel ? `涉及预测: ${r.sourceSkuLabel}` : ''
        };
      });

      this.visible = true;

      // 智能匹配历史采购记录：自动为欠料物料带出最近一次的供应商和采购价
      const matNos = shortageRows.map(r => r.matNo).filter(Boolean);
      if (matNos.length) {
        this.fetchRecentSuppliers(matNos);
      }
    },

    /**
     * 根据物料编码查询最近采购订单 (V_po_orddtl) 匹配最近供应商与单价
     * @param {Array<string>} matNos 物料编码列表
     */
    fetchRecentSuppliers(matNos) {
      if (!matNos || !matNos.length) return;
      const inClause = matNos.map(m => `'${m}'`).join(',');
      const sql = `select matno, supno, supnm, prc from (select matno, supno, supnm, prc, row_number() over(partition by matno order by orddttm desc) as rn from v_po_orddtl where corpid='${this.corpid}' and matno in (${inClause})) where rn = 1`;
      this.$axios.post('xuper_auth/getFreeData', {
        p_cond: sql
      }).then(res => {
        if (res && res.code === '200' && Array.isArray(res.result) && res.result.length) {
          const map = {};
          res.result.forEach(item => {
            if (item.MATNO) map[item.MATNO] = item;
          });
          this.dtlData.forEach(row => {
            if (map[row.MATNO]) {
              if (!row.SUPNO) {
                row.SUPNO = map[row.MATNO].SUPNO || '';
                row.SUPNM = map[row.MATNO].SUPNM || '';
              }
              if ((!row.PRC || Number(row.PRC) === 0) && map[row.MATNO].PRC) {
                row.PRC = Number(map[row.MATNO].PRC);
                this.calcRowAmt(row);
              }
            }
          });
        }
      }).catch(() => {});
    },

    /** 工具栏一键批量为全部明细分配供应商 */
    applyBatchSupplier() {
      const supNo = this.batchSupNo;
      const supNm = this.batchSupNm || supNo;
      if (!supNo && !supNm) {
        this.$message.warning('请先在下拉表格中选择要批量分配的供应商');
        return;
      }
      this.dtlData.forEach(r => {
        r.SUPNO = supNo;
        r.SUPNM = supNm;
      });
      this.$message.success(`已批量为 ${this.dtlData.length} 项物料分配供应商【${supNm}】`);
    },

    calcRowAmt(row) {
      const q = Number(row.QTY) || 0;
      const p = Number(row.PRC) || 0;
      row.AMT = (q * p).toFixed(2);
    },

    perDel(index) {
      this.dtlData.splice(index, 1);
    },

    async saveRec() {
      if (!this.dtlData.length) {
        this.$message.warning('明细记录不能为空');
        return;
      }

      for (let i = 0; i < this.dtlData.length; i++) {
        const row = this.dtlData[i];
        if (!row.MATNO) {
          this.$message.error(`第 ${i + 1} 行物料编码不能为空`);
          return;
        }
        if (!row.QTY || Number(row.QTY) <= 0) {
          this.$message.error(`物料【${row.MATNM || row.MATNO}】申请数量必须大于0`);
          return;
        }
      }

      this.saving = true;
      try {
        // 1. 保存主表 PO_REQ
        const mainPayload = {
          ...this.mainRow,
          CORPID: this.corpid,
          AMT: this.totalDtlAmt,
          ACTFEE: this.totalDtlAmt
        };

        const mainRes = await this.$axios.post('xuper_auth/formOneSave', {
          p_table: 'po_req',
          frmid: '95',
          p_json: JSON.stringify(mainPayload)
        });

        if (!mainRes || mainRes.result !== 'OK' || !mainRes.idseq) {
          throw new Error((mainRes && mainRes.result) ? mainRes.result : '保存采购申请单主表失败');
        }

        const newIdseq = mainRes.idseq;
        const newIdno = mainRes.idno || '';

        // 2. 批量保存明细表 PO_REQDTL (包含供应商字段 SUPNO, SUPNM)
        const dtlPayload = this.dtlData.map((row, idx) => ({
          IDSEQ: newIdseq,
          RN: idx + 1,
          MATTYPE: row.MATTYPE || 'MAT',
          MATNO: row.MATNO,
          MATNM: row.MATNM,
          SPECNM: row.SPECNM || '',
          MATDESC: row.SPECNM || '',
          UNITNM: row.UNITNM || '',
          QTY: Number(row.QTY),
          PRC: Number(row.PRC) || 0,
          AMT: Number(row.AMT) || 0,
          SUPNO: row.SUPNO || '',
          SUPNM: row.SUPNM || '',
          REQDTTM: row.REQDTTM,
          RMK: row.RMK || ''
        }));

        const dtlRes = await this.$axios.post('xuper_auth/batDtlSave2', {
          p_table: 'po_reqdtl',
          p_idseq: newIdseq,
          p_action: 'S',
          p_json: JSON.stringify(dtlPayload)
        });

        if (!dtlRes || dtlRes.code !== '200') {
          throw new Error((dtlRes && dtlRes.result) ? dtlRes.result : '写入请购明细失败');
        }

        // 3. 反馈与通知
        this.$notify({
          title: '采购申请单已生成',
          message: newIdno ? `已生成申请单【${newIdno}】，包含 ${dtlPayload.length} 项欠料明细！` : `已成功保存采购申请单及 ${dtlPayload.length} 项欠料明细！`,
          type: 'success',
          duration: 5000
        });

        this.visible = false;
        this.$emit('success', { idseq: newIdseq, idno: newIdno, items: dtlPayload });

      } catch (err) {
        this.$message.error('保存失败：' + (err && err.message ? err.message : '接口异常'));
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style lang="less">
/* 
 * 采购申请单专属弹窗样式 (完全限定在 .po-req-custom-dialog-wrapper 与 .po-req-custom-dialog 命名空间内)
 * 严格保证 100% 物理隔离，绝对不影响系统中其他任何 Vue 页面或公共弹窗样式！
 */
.po-req-custom-dialog-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  &[style*="display: none"] {
    display: none !important;
  }

  .po-req-custom-dialog {
    margin: 0 !important;
    position: relative !important;
    border-radius: 8px !important;
    overflow: hidden !important;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.15), 0 10px 10px -5px rgba(0, 0, 0, 0.05) !important;
    background: #ffffff !important;

    /* 标题栏：白底无彩色背景，与齐套料页面完全一致 */
    .el-dialog__header {
      padding: 0 !important;
      background: #ffffff !important;
      height: 48px;
      line-height: 48px;
      border-bottom: 1px solid #e2e8f0 !important;
      position: relative;

      .dialog-clean-header {
        display: flex;
        align-items: center;
        height: 48px;
        padding: 0 20px;

        .header-main-title {
          font-size: 15px;
          font-weight: 600;
          color: #0f172a;
          letter-spacing: 0.2px;
        }

        .header-sub-tag {
          margin-left: 10px;
          background: #f1f5f9;
          color: #64748b;
          font-size: 12px;
          padding: 2px 8px;
          border-radius: 4px;
          border: 1px solid #e2e8f0;
          font-weight: 400;
        }
      }

      /* 右上角关闭按钮：极简纯净灰黑叉叉，彻底消除白框方块 */
      .el-dialog__headerbtn {
        top: 14px !important;
        right: 18px !important;
        width: 22px !important;
        height: 22px !important;
        line-height: 22px !important;
        background: transparent !important;
        border: none !important;

        .el-dialog__close {
          color: #94a3b8 !important;
          font-size: 17px !important;
          font-weight: 500;
          transition: all 0.15s ease;
        }

        &:hover .el-dialog__close {
          color: #0f172a !important;
        }
      }
    }

    .el-dialog__body {
      padding: 0 !important;
      background-color: #f8fafc;
    }

    .dialog-scroll-body {
      max-height: calc(88vh - 105px);
      overflow-y: auto;
      padding: 12px 16px;

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background: #cbd5e1;
      border-radius: 3px;
    }
  }

  /* 模块 1：基本信息面板 */
  .panel-section-box {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 10px 14px 2px;
    margin-bottom: 12px;

    .panel-section-head {
      display: flex;
      align-items: baseline;
      margin-bottom: 8px;

      .head-title {
        font-size: 13px;
        font-weight: 600;
        color: #0f172a;
      }

      .head-subtitle {
        font-size: 11px;
        color: #94a3b8;
        margin-left: 8px;
      }
    }

    .clean-form-grid {
      .el-form-item {
        margin-bottom: 8px;
        margin-right: 14px;

        .el-form-item__label {
          font-size: 12px;
          color: #64748b;
          padding-right: 6px;
          font-weight: 400;
        }

        .el-input__inner {
          border-radius: 4px;
          border-color: #e2e8f0;
          height: 30px;
          line-height: 30px;
          font-size: 12px;

          &:focus {
            border-color: #2563eb;
          }
        }

        .el-input.is-disabled .el-input__inner {
          background-color: #f8fafc;
          color: #94a3b8;
          border-color: #e2e8f0;
        }
      }

      .form-item-full {
        width: calc(100% - 14px);
        margin-right: 0;

        .el-form-item__content {
          width: calc(100% - 80px);
        }
      }
    }
  }

  /* 模块 2：请购明细卡片 */
  .detail-card-panel {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    overflow: hidden;

    .detail-toolbar-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #ffffff;
      border-bottom: 1px solid #e2e8f0;
      padding: 8px 12px;
      flex-wrap: wrap;
      gap: 8px;

      .toolbar-left {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;

        .detail-title {
          font-size: 13px;
          font-weight: 600;
          color: #0f172a;
        }

        .detail-count-badge {
          font-size: 11px;
          color: #64748b;
          background: #f1f5f9;
          padding: 1px 6px;
          border-radius: 4px;
          border: 1px solid #e2e8f0;
          margin-right: 6px;
        }

        /* 批量分配一体化组合：精致极简，消除突兀色块 */
        .batch-alloc-inline {
          display: inline-flex;
          align-items: center;
          height: 28px;
          margin-left: 10px;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 4px;
          padding-left: 8px;

          .batch-alloc-label {
            font-size: 12px;
            color: #64748b;
            margin-right: 4px;
            white-space: nowrap;
          }

          .batch-alloc-field {
            width: 175px;

            .el-input__inner {
              border: none !important;
              background: transparent !important;
              height: 26px !important;
              line-height: 26px !important;
              font-size: 12px !important;
              padding-left: 4px !important;
            }
          }

          .btn-batch-apply {
            height: 26px;
            line-height: 26px;
            padding: 0 10px;
            font-size: 12px;
            color: #0f172a;
            background: #ffffff;
            border: none;
            border-left: 1px solid #e2e8f0;
            border-radius: 0 3px 3px 0;
            cursor: pointer;
            font-weight: 500;
            transition: all 0.15s ease;

            &:hover:not(:disabled) {
              background: #2563eb;
              color: #ffffff;
            }

            &:disabled {
              color: #cbd5e1;
              cursor: not-allowed;
              background: #f8fafc;
            }
          }
        }
      }

      .toolbar-stat-right {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-left: auto;

        .stat-cell {
          font-size: 12px;
          color: #64748b;

          b {
            color: #0f172a;
            font-weight: 600;
          }

          b.amt {
            color: #d97706;
          }
        }

        .stat-sep {
          color: #e2e8f0;
        }
      }
    }

    .po-req-detail-table {
      width: 100%;

      .el-table__header th {
        background: #f8fafc !important;
        color: #475569 !important;
        font-weight: 600;
        font-size: 12px;
        padding: 5px 0;
        border-bottom: 1px solid #e2e8f0 !important;
      }

      .el-table__body td {
        padding: 2px 0;
        border-color: #f1f5f9;
      }

      .el-table__row:hover > td {
        background-color: #f8fafc !important;
      }

      .cell-matno {
        font-family: monospace;
        font-size: 12px;
        font-weight: 500;
        color: #0f172a;
      }

      .btn-clean-del {
        color: #94a3b8;
        font-size: 12px;
        padding: 0;

        &:hover {
          color: #ef4444;
        }
      }
    }
  }

    /* 模块 3：弹窗底部操作栏 */
    .dialog-custom-footer {
      height: 52px;
      background: #ffffff;
      border-top: 1px solid #e2e8f0;
      padding: 0 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .footer-summary {
        font-size: 12px;
        color: #64748b;
      }

      .footer-btns {
        display: flex;
        gap: 10px;

        .btn-cancel {
          height: 32px;
          padding: 0 16px;
          border-radius: 4px;
          background: #ffffff;
          border: 1px solid #e2e8f0;
          color: #475569;

          &:hover {
            border-color: #cbd5e1;
            color: #0f172a;
          }
        }

        .btn-confirm {
          height: 32px;
          padding: 0 16px;
          border-radius: 4px;
          background: #2563eb;
          border-color: #2563eb;
          color: #ffffff;
          font-weight: 500;

          &:hover {
            background: #1d4ed8;
            border-color: #1d4ed8;
          }
        }
      }
    }
  }
}
</style>
